import React from "react";
import { Zap } from "lucide-react";

const TOOLTIP =
  "On: includes in-progress overrides immediately. " +
  "Off: includes overrides only after processing completes.";

const PendingOverridesToggle = ({ checked, onChange, disabled = false }) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <span
      className={`forecast-pending-toggle${
        disabled ? " forecast-pending-toggle--disabled" : ""
      }`}
      title={TOOLTIP}
    >
      <Zap size={14} className="forecast-pending-toggle__icon" />
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label="Include pending overrides"
        className={`forecast-pending-toggle__switch${
          checked ? " forecast-pending-toggle__switch--on" : ""
        }`}
        onClick={handleClick}
        disabled={disabled}
      >
        <span className="forecast-pending-toggle__thumb" />
      </button>
    </span>
  );
};

export default PendingOverridesToggle;
